export default __webpack_public_path__ + "static/media/app_store.19aa6d90.webp";